function revealSubCategory(currIdentifier, currIndex) {
	if (!!document.querySelectorAll('.category-image')) {
		document.querySelectorAll('.category-image').forEach(img => {
			img.removeAttribute('reveal')
		})
	}
	if (!!document.querySelector('.product_categories-content.is-selected')) {
		let selectedIndex = null
		let selectedCategory = null
		if (!!currIdentifier) {
			selectedCategory = currIdentifier
		} else {
			selectedCategory = document.querySelector('.product_categories-content.is-selected').getAttribute('data-selected-category')
		}
		if (!!currIndex) {
			selectedIndex = currIndex
		} else {
			selectedIndex = document.querySelector('.product_categories-content.is-selected').getAttribute('data-selected-index')
		}
		if (!!document.querySelectorAll('.product-subcategories__wrapper')) {
			let allSubcategories = document.querySelectorAll('.product-subcategories__wrapper')
			allSubcategories.forEach(subcategorie => {
				if (!!selectedCategory) {
					if (!!subcategorie.getAttribute('data-subcategory-index') && !!subcategorie.getAttribute('data-selected-category')) {
						let subcategorieSelected = subcategorie.getAttribute('data-selected-category')
						let indexSelected = subcategorie.getAttribute('data-subcategory-index')

						if (selectedCategory === subcategorieSelected && selectedIndex == indexSelected) {
							subcategorie.classList.remove('hidden')
						} else {
							subcategorie.classList.add('hidden')
						}
					}
				}
			})
		}

		if (!!document.querySelectorAll('.product_categories-text')) {
			let allCategoriesContent = document.querySelectorAll('.product_categories-text')
			allCategoriesContent.forEach(content => {
				if (!!selectedCategory) {
					if (!!content.getAttribute('data-selected-category') && !!content.getAttribute('data-selected-index')) {
						let categorieSelected = content.getAttribute('data-selected-category')
						let categorieIndexSelected = content.getAttribute('data-selected-index')

						if (selectedCategory === categorieSelected && selectedIndex == categorieIndexSelected) {
							content.classList.remove('hidden');
						} else {
							content.classList.add('hidden');
						}
					}
				}
			})

		}
		selectedIndex = null
		selectedCategory = null
	}
}
document.addEventListener("DOMContentLoaded", function (e) {
	function categoryChange() {
		if (!!document.querySelectorAll('.product-subcategories__wrapper')) {
			let subcategoriesWrapper = document.querySelectorAll('.product-subcategories__wrapper')
			handleElementsLoop(true, subcategoriesWrapper, '.category-buttons-name')
		}
		if (document.querySelectorAll('.category-main-buttons-name')) {
			let categoryMainButtons = document.querySelectorAll('.category-main-buttons-name')
			handleElementsLoop(false, categoryMainButtons)
		}
	}

	function handleElementsLoop(isSub, targetElements, targetClass) {
		if (!!targetElements) {
			targetElements.forEach((targetElement, index) => {
				if (isSub) {
					if (!!targetElement.querySelectorAll(targetClass)) {
						targetElement.querySelectorAll(targetClass).forEach(target => {
							target.addEventListener("click", function (element) {
								handleElementClick(element, targetElement, index, true)
							});
						})
					}
				} else {
					targetElement.addEventListener("click", function (element) {
						handleElementClick(element, targetElements, index, false)
					});
				}
			});
		}
	}
	let clickedElements = []

	function handleElementClick(element, category, index, isSub) {
		let currIdentifier = null
		let prevIdentifier = null
		let currentTarget = null
		let previouslyClickedElement = null;
		let currentClickedElement = element.target;

		if (isSub) {
			previouslyClickedElement = currentClickedElement.previousElementSibling ? currentClickedElement.previousElementSibling : currentClickedElement.nextElementSibling;
			// Remove the class from the previously clicked element
			if (!!previouslyClickedElement) {
				previouslyClickedElement.classList.remove("is--selected");
				if (!!previouslyClickedElement.getAttribute('data-identifier-button')) {
					prevIdentifier = previouslyClickedElement.getAttribute('data-identifier-button')
				}
			}
			// Add the class to the current clicked element
			if (!!currentClickedElement) {
				currentClickedElement.classList.add("is--selected");
				if (!!currentClickedElement.getAttribute('data-identifier-button')) {
					currIdentifier = currentClickedElement.getAttribute('data-identifier-button')
				}
			}
			if (!!category && !!prevIdentifier) {
				let prevSubcategoryContent = category.querySelector(`[data-identifier="${prevIdentifier}"]`)
				if (!!prevSubcategoryContent) {
					prevSubcategoryContent.style.opacity = 0
					prevSubcategoryContent.classList.add('hidden')
				}
			}

			if (!!category && !!currIdentifier) {
				let subcategoryContent = category.querySelector(`[data-identifier="${currIdentifier}"]`)
				if (!!subcategoryContent) {
					subcategoryContent.classList.remove('hidden')
					setTimeout(function () {
						subcategoryContent.style.opacity = 1;
					}, 100);
				}
			}
		} else {
			currentTarget = element.target
			currentClickedElement = currentTarget;
			let currentIndex = null
			if (!!currentClickedElement) {
				currentClickedElement.classList.add("is--selected");
				if (!!currentClickedElement.getAttribute('data-category-name')) {
					currIdentifier = currentClickedElement.getAttribute('data-category-name')
					currentIndex = currentClickedElement.getAttribute('data-index')
				}
			}

			clickedElements.push(currentClickedElement)

			if (clickedElements.length > 1) {
				previouslyClickedElement = clickedElements[clickedElements.length - 2];
			} else {
				previouslyClickedElement = category[0]
			}

			if (!!previouslyClickedElement) {
				previouslyClickedElement.classList.remove("is--selected");
				if (!!previouslyClickedElement.getAttribute('data-category-name')) {
					prevIdentifier = previouslyClickedElement.getAttribute('data-category-name')
				}
			}

			if (!!prevIdentifier) {
				let prevMainCategoryContent = document.querySelector(`[data-main-category="${prevIdentifier}"]`)
				if (!!prevMainCategoryContent) {
					prevMainCategoryContent.style.opacity = 0
					setTimeout(function () {
						prevMainCategoryContent.classList.add('hidden')
					}, 100);

				}
			}
				
			if (!!currIdentifier) {
				let mainCategoryContent = document.querySelector(`[data-main-category="${currIdentifier}"]`)
				if (!!mainCategoryContent) {
					mainCategoryContent.classList.remove('hidden')
					setTimeout(function () {
						mainCategoryContent.style.opacity = 1;
					}, 100);
				}
			}
			revealSubCategory(currIdentifier, currentIndex)
		}
		currentClickedElement = null
	}
	categoryChange()
	revealSubCategory()
});

function variantChangePortions(id, available) {
	if (available === false) {
		if (!!document.querySelector('.product-get-it-text')) {
			document.querySelector('.product-get-it-text').style.display = "none"
		}
	} else {
		if (!!document.querySelector('.product-get-it-text')) {
			document.querySelector('.product-get-it-text').style.display = "block"
		}
	}

	if (!!document.querySelector(`.price_label--serving--${id}`)) {
		let dataPortions = document.querySelector(`.price_label--serving--${id}`).getAttribute('data-portions');
		let dataPortionsPrice = document.querySelector(`.price_label--serving--${id}`).getAttribute('data-price-per-serving');
		if (!!document.querySelector('.price_label--serving--portions') && !!dataPortions) {
			document.querySelector('.price_label--serving--portions').innerHTML = dataPortions;
		}
		if (!!document.querySelector('.price_label--serving-price-portions') && !!dataPortionsPrice) {
			document.querySelector('.price_label--serving-price-portions').innerHTML = dataPortionsPrice;
		}
	}
}

window.addEventListener("flickity:slide-settled", function (e) {
	if (!!e.target) {
		const computedStyle = window.getComputedStyle(e.target);
		if (computedStyle.opacity != '0') {
			if (!!e.target.getAttribute('data-main-category') && e.target.querySelector('.is-selected')) {
				let mainCategory = e.target.getAttribute('data-main-category')
				let selectedIndex = e.target.querySelector('.is-selected').getAttribute('data-selected-index')
				revealSubCategory(mainCategory, selectedIndex)
			}
		}
	}
});
function changeVariantId(variantId) {
	if (!!document.querySelectorAll('.upsell-main-product')) {
		let upsellMainProduct = document.querySelectorAll('.upsell-main-product')
		upsellMainProduct.forEach(upsell=>{
			upsell.value = variantId
		})
	}
}
document.addEventListener("variant:changed", function (e) {
	if (!!e.detail) {
		changeVariantId(e.detail.variant.id)
		variantChangePortions(e.detail.variant.id, e.detail.variant.available)
	}
})

document.addEventListener("DOMContentLoaded", function (e) {
	// Get the modal
	const zoomModal = document.getElementById('zoomModal');
	const modalImg = document.getElementById("zoomImage");
	let subCategorieImage = document.querySelectorAll('.product-subcategories-image__wrapper')
	if (!!subCategorieImage) {
		 subCategorieImage.forEach(el=>{
			 let imgs = el.querySelectorAll('.product-subcategories-image--zoom');
			 imgs.forEach(img =>{
				 img.addEventListener('click', function(e){
					 if (!!zoomModal) {
						 zoomModal.style.display = "flex";
					 }
					 if (!!modalImg) {
						if (!!e.target.src) {
							modalImg.src = e.target.src;
						}
						if (!!e.target.getAttribute('data-src')) {
							modalImg.src = e.target.getAttribute('data-src');
						}
					 }
				 })
			 })
 
			 if (!!zoomModal) {
				 zoomModal.addEventListener('click', function(e){
					 if(!!modalImg){
						 modalImg.className += " out";
						 setTimeout(function() {
							 zoomModal.style.display = "none";
							 modalImg.className = "modal-content";
						 }, 400);
					 }
				 })		
			 }
		})
	 }
 })